export default __webpack_public_path__ + "static/media/b8.fb88d43f.jpg";